import cn from "classnames";
import styles from "./export-view.module.css";

export const ExportButton = ({
  onClick,
  isExporting,
  disabled = false,
}: {
  onClick: () => void;
  isExporting: boolean;
  disabled?: boolean;
}) => {
  return (
    <button
      className={cn(styles.exportButton, disabled && styles.disabled, isExporting && styles.exporting)}
      onClick={onClick}
      disabled={isExporting || disabled}
      aria-busy={isExporting}
      aria-disabled={disabled}
    >
      {isExporting ? "Exporting..." : "Export"}
    </button>
  );
};
